import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box, Typography, TextCharLimit/* , Dropdown, DropdownMenuItem */} from 'views/components';
import {Translate, translate, MarkdownEditor} from 'views/module';

const EventInfo = (props) => {
  const newEvent = props.newEvent;
  const updateEventInfo = props.updateEventInfo;
  // const updateShiftType = props.updateShiftType;
  const setIsStepValid = props.setIsStepValid;
  const clientData = props.clientData;

  const info = newEvent?.info || {};

  const title = info.title;
  const description = info.description?.blob;
  // const shiftType = newEvent?.shiftType || 'REGULAR_CARE';

  const setTitle = (newValue) => {
    updateEventInfo((e) => {
      return {
        ...e,
        title: newValue,
      };
    });
  };
  const setDescription = (newValue) => {
    updateEventInfo((e) => {
      return {
        ...e,
        description: {
          blob: newValue,
          editorType: 'MARKDOWN',
        },
      };
    });
  };

  React.useEffect(() => {
    if (!newEvent.info) {
      updateEventInfo((e) => {
        return {
          title: clientData.clientName,
          description: {
            blob: '',
            editorType: 'MARKDOWN',
          },
        };
      });
    }
  }, [info]);

  React.useEffect(() => {
    setIsStepValid(title);
  }, [title]);

  return (
    <Stack direction='column' spacing={2} wrap='nowrap'>
      <Box>
        <TextCharLimit
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Title')}
          value={title}
          onChange={setTitle}
          charLimit={180}
        />
      </Box>
      <Stack spacing={1}>
        <Box sx={{display: 'flex', alignContent: 'left'}}>
          <Typography variant='description1' sx={{fontWeight: 500}}>
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.Description' />
          </Typography>
        </Box>
        <Box xs={12}>
          <MarkdownEditor
            value={description}
            onChange={setDescription}
          />
        </Box>
      </Stack>
      {/* Shift type — temporarily hidden
      <Box>
        <Dropdown
          value={shiftType}
          onChange={updateShiftType}
          label={translate('client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.ShiftType.Label')}
        >
          {
            ['REGULAR_CARE', 'FIRST_SHIFT_LONG_TERM_CLIENT', 'MEET_AND_GREET', 'ONE_TIME_REPLACEMENT', 'TEMPORARY_REPLACEMENT'].map((shiftTypeKey) => {
              return (
                <DropdownMenuItem key={shiftTypeKey} value={shiftTypeKey}>
                  {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventInfo.ShiftType.Options.${shiftTypeKey}`)}
                </DropdownMenuItem>
              );
            })
          }
        </Dropdown>
      </Box>
      */}
    </Stack>
  );
};

EventInfo.propTypes = {
  newEvent: PropTypes.object.isRequired,
  updateEventInfo: PropTypes.func.isRequired,
  // updateShiftType: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
  clientData: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, dispatch)(React.memo(EventInfo));
